import styled from 'styled-components';

import { useGlobalStore } from '../../state/globalStore';
import {
  BUTTON_ROLES,
  BUTTON_TEXT_TYPE,
  RTF_BUTTON_TEXT_STYLE_VALUE,
  RTF_BUTTON_TYPES_VALUES,
} from '../../utils/constants';
import Loading from '../loading/Loading';

interface Props {
  role: string;
  disabled?: boolean;
  onClick?: () => void;
  loading?: boolean;
  textType: string;
}

type ButtonStyleType = {
  border?: string;
  backgroundColor?: string;
};

type ContextStyleType = {
  fontWeight?: number;
  fontStyle?: string;
  color?: string;
  fontFamily?: string;
  textDecoration?: string;
};

//Button text styles values
const BOLD = 700;
const ITALIC = 'italic';
const UNDERLINE = 'underline';
const TRANSPARENT = 'transparent';

export const StylableButton = ({
  role,
  textType,
  loading = false,
  disabled,
  onClick,
  ...props
}: Props) => {
  const leadCapture = useGlobalStore((state) => state.leadCapture);
  const { primaryButtonStyle, secondaryButtonStyle } = leadCapture;
  const defaultValues = role === BUTTON_ROLES.PRIMARY ? primaryButtonStyle : secondaryButtonStyle;
  const {
    loginButtonText,
    registerButtonText,
    backButtonText,
    nextButtonText,
    textColor,
    buttonColor,
    type,
    style,
  } = defaultValues;

  const getTextValue = () => {
    switch (textType) {
      case BUTTON_TEXT_TYPE.BACK:
        return backButtonText;
      case BUTTON_TEXT_TYPE.NEXT:
        return nextButtonText;
      case BUTTON_TEXT_TYPE.REGISTER:
        return registerButtonText;
      case BUTTON_TEXT_TYPE.LOGIN:
        return loginButtonText;
    }
    return '';
  };

  const getTextStyle = () => {
    const currStyle: ContextStyleType = {};
    if (style?.includes(RTF_BUTTON_TEXT_STYLE_VALUE.BOLD)) currStyle.fontWeight = BOLD;
    if (style?.includes(RTF_BUTTON_TEXT_STYLE_VALUE.ITALIC)) currStyle.fontStyle = ITALIC;
    if (style?.includes(RTF_BUTTON_TEXT_STYLE_VALUE.UNDERLINE))
      currStyle.textDecoration = UNDERLINE;
    return {
      ...currStyle,
      color: textColor,
    };
  };

  const getButtonStyle = () => {
    let currStyle: ButtonStyleType = {};
    const btnColor = buttonColor;
    if (type === RTF_BUTTON_TYPES_VALUES.SOLID) {
      delete currStyle.border;
      currStyle.backgroundColor = btnColor;
    } else {
      currStyle.backgroundColor = TRANSPARENT;
      currStyle.border = `1px solid ${btnColor}`;
    }
    return currStyle;
  };
  return (
    <UnitWrapper>
      <StyledButton
        {...props}
        onClick={() => {
          if (!disabled) {
            onClick?.();
          }
        }}
        style={getButtonStyle()}
      >
        {loading ? (
          <StyledLoading color={textColor || '#FFFFFF'} height={36} width={36} />
        ) : (
          <span style={getTextStyle()}>{getTextValue() || ''}</span>
        )}
      </StyledButton>
    </UnitWrapper>
  );
};

const StyledLoading = styled(Loading)<{ color: string }>`
  circle {
    stroke: ${({ color }) => color};
  }
`;

const UnitWrapper = styled.div`
  width: 100%;
  position: relative;
`;

const StyledButton = styled.button`
  height: 40px;
  width: 100%;
  font-size: 14px;
  margin: auto;
  border-radius: 8px;
  border: 0px;
  cursor: pointer;
`;
